// utils/loadTDT.js
let loading
export default function loadTDT(tk) {
  if (window.T) return Promise.resolve(window.T)
  if (loading) return loading
  const url = `https://api.tianditu.gov.cn/api?v=4.0&tk=${tk}`
  loading = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = url
    script.onload = () => resolve(window.T)
    script.onerror = reject
    document.head.appendChild(script)
  })
  return loading
}
